import moment from 'moment'

import { longDateShortMonthTime } from 'utils'

export const DateTime: TAnt.TableColumnRender<string> = (createdAt) => (
  <>{moment(createdAt).format(longDateShortMonthTime).toLowerCase()}</>
)
